module.exports = __webpack_public_path__ + "static/Danzza-Medium-c38bbbbc60f1cec0054df03ad16feefe.woff2";